import { useTranslation } from 'react-i18next';
import { Button, ButtonProps } from '@/Domain/components/Shared/Button/Button';
import { McpClaudeIcon } from '@/Domain/components/icons/McpClaude.icon';
import { OpenAiIcon } from '@/Domain/components/icons/OpenAi.icon';
import { AccountMcpSource } from '@/Domain/enum/PostHogEvent.enum';
import { MODAL_NAMES, useModalStore } from '@/Domain/store/modal.store';

/**
 * Reusable trigger that opens the account-MCP connect sheet. Drop it anywhere a
 * "Use in ChatGPT / Claude" entry point makes sense (page headers, empty
 * states). Style overrides pass through via ButtonProps; the label defaults to
 * the shared CTA string but can be overridden with children. `source` tags the
 * AccountMcpOpened analytics event with the entry point.
 */
export const AccountMcpConnectButton = ({
  children,
  source = 'identity_button',
  ...props
}: ButtonProps & { source?: AccountMcpSource }) => {
  const { t } = useTranslation('account_mcp');
  const { toggleModal } = useModalStore();

  return (
    <Button
      variant="secondary"
      size="sm"
      data-testid="account-mcp-connect-button"
      {...props}
      onClick={() => toggleModal(MODAL_NAMES.ACCOUNT_MCP_SHEET, { source })}
    >
      {children ?? t('cta')}
      <OpenAiIcon className="size-4" />
      <McpClaudeIcon className="size-4" />
    </Button>
  );
};
